import React, { useEffect } from 'react';
import { Route, Navigate } from 'react-router-dom';
import Layout, { BASE, DISCORD } from './Layout';
import Home from './Home';
import Research, { Article } from './Research';
import Log from './Log';

// react-router can't <Navigate> off-origin; do a real document redirect.
function External({ to }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
}

// Spliced into <Routes> in src/App.js. Everything the site is lives in this folder.
const routes = (
  <>
    <Route path={BASE} element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="research" element={<Research />} />
      <Route path="research/:slug" element={<Article />} />
      <Route path="log" element={<Log />} />
      <Route path="*" element={<Navigate to={BASE} replace />} />
    </Route>
    <Route path={`${BASE}/discord`} element={<External to={DISCORD} />} />
    <Route path="/projects/iteration-body-labs" element={<Navigate to={BASE} replace />} />
  </>
);

export default routes;
